import React, { useCallback, useEffect, useRef, useState } from 'react'
import { DI, DIProps } from '../../../Core';
import { ActionList, Box, Button, ButtonGroup, Checkbox, EmptyState, InlineStack, Icon, Link, Pagination, Popover, Tabs, Tag, Text, TextField, BlockStack, Bleed, Divider } from '@shopify/polaris';
import { ArchiveMajor, ExternalSmallMinor, ImportMinor, MobileCancelMajor } from '@shopify/polaris-icons';
import NoResultsFound from '../../../Asests/Images/NoResultsFound.png';
import './Styles/NewStyles.css';
import { Table } from 'antd';
import RenderStatus from './Components/RenderStatus';
import RenderSyncStatus from './Components/RenderSyncStatus';
import { customModal, formattedDate, getAmazonOrderUrl, getShopifyOrderId, getShopifyShopUrl, getTotalPrice, paramKey } from './Utils/Helper';
import { AmazonIcon, ShopifyIcon } from '../../../Asests/svgIcon/icon';
import RenderTags from './Components/RenderTags';
import RenderActions from './Components/RenderActions';
import RenderOrderItems from './Components/RenderOrderItems';
import { allOrdersColumns, optionsSelect, ordersFilter } from './Utils/Constants';
import RenderFilters from './Components/FIlters/RenderFilters';
import { ObjectI, PayloadI, ArchiveI, OrderFilterI, TabsI, Filter, FailedStatus } from './Utils/Interface';
import { useSearchParams } from 'react-router-dom';
import { rows as skeletonRow } from './Utils/skeleton/FullfillmentSkeleton';
import { isAdminLoggedIn } from '../Panel/index';
import { useTranslation } from 'react-i18next';
import { necessaryInfo } from '../Overview/Utils/HelperFunc';
interface props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

const NewAllSales = (props: props) => {
    const { t } = useTranslation();
    let { allOrderCols } = allOrdersColumns();
    let { selectOption } = optionsSelect();
    const tableref = useRef<HTMLTableElement>(document.createElement("table"));
    const prevInput = useRef('');
    const pageSize: number = 10;
    const [searchParams, setSearchParams] = useSearchParams();
    const [filter, setFilter] = useState<OrderFilterI>(
        Object.keys(JSON.parse(props.di.globalState.get('orders_filter', true) ?? '{}')).length > 0
            ? JSON.parse(props.di.globalState.get('orders_filter', true) ?? '{}')
            : JSON.parse(JSON.stringify({ ...ordersFilter }))
    );
    const [appliedFilters, setAppliedFilters] = useState<any>({});
    const [selectedDate, setSelectedDate] = useState<string[]>(['Select Date']);
    const [selected, setSelected] = useState<number>(0);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [activePage, setActivePage] = useState<number>(1);
    const [inputValue, setInputValue] = useState<string>('');
    const [showSkeleton, setShowSkeleton] = useState<boolean>(true);
    const [loader, setLoader] = useState<boolean>(true);
    const [selectedRows, setSelectedRows] = useState<Array<string>>([]);
    const [selectedOrderID, setselectedOrderID] = useState<Array<string>>([]);
    const [DataForRow, setDataforRow] = useState<Array<any>>([]);
    const [gridRows, setGridRows] = useState<Array<any>>([]);
    const [popoverActive, setPopoverActive] = useState<boolean>(false);
    const [activateImportModal, setActivateImportModal] = useState<boolean>(false);
    const [importOrderId, setImportOrderId] = useState<string>('');
    const [importError, setImportError] = useState<boolean>(false);
    const [importLoader, setImportLoader] = useState<boolean>(false);
    const [orderStatus, setOrderStatus] = useState<string>("all");
    const [errorTabCount, setErrorTabCount] = useState<string>('-');
    const [totalOrders, setTotalOrders] = useState<number>(0);
    let [archiveModal, setArchiveModal] = useState<ArchiveI>({
        open: false,
        loader: false
    })

    /**
     * Orders grid tabs
     */
    const tabs: Array<TabsI> = [
        {
            id: "all",
            content: t('All'),
        },
        {
            id: 'errors',
            content: t('Errors'),
            badge: errorTabCount,
        }
    ];

    // Executes getAllOrders and getErrorCount functions after a delay of 1000ms
    useEffect(() => {
        const timeout = setTimeout(() => {
            getAllOrders();
            getErrorCount();
        }, 1000);
        return () => clearTimeout(timeout);
    }, [activePage, orderStatus, inputValue, filter]);

    // Hide or show the header of the table based on the selected rows
    useEffect(() => {
        selectedRows.length > 0 ? tableref.current?.classList.add("header-hidden") : tableref.current?.classList.remove("header-hidden")
    }, [selectedRows]);

    // Updates grid rows based on the fetched data
    useEffect(() => {

        let temp: Array<ObjectI> = [];
        DataForRow?.length !== 0 && DataForRow?.map((row: any, idx: number) => {

            let orderId = getShopifyOrderId(row);
            let shopUrl = getShopifyShopUrl(orderId, props);


            temp?.push({
                key: row?.['cif_order_id'] ?? idx + Math.random(),
                id: <BlockStack gap="200">
                    <InlineStack gap="200" blockAlign='center' wrap={false}>
                        <AmazonIcon />
                        <Link removeUnderline target='_blank' url={getAmazonOrderUrl(row?.marketplace_reference_id, props)}>
                            <InlineStack gap="100" wrap={false}>
                                <Text as='span'>{row?.['marketplace_reference_id'] ?? "N/A"}</Text>
                                <Icon source={ExternalSmallMinor} tone="base" />
                            </InlineStack>
                        </Link>
                    </InlineStack>
                    <InlineStack gap="200" blockAlign='center' wrap={false}>
                        <ShopifyIcon />
                        <Text as="span" tone='subdued'>
                            {
                                shopUrl && shopUrl != "" ?
                                    <Link removeUnderline target='_blank' url={shopUrl}>
                                        <InlineStack gap="100" wrap={false}>
                                            <Text as='span'>{orderId}</Text>
                                            <Icon source={ExternalSmallMinor} tone="base" />
                                        </InlineStack>
                                    </Link> : "-"
                            }
                        </Text>
                    </InlineStack>
                </BlockStack>,
                status: <RenderStatus row={row} getAllOrders={getAllOrders} />,
                sync_status: <RenderSyncStatus row={row} getAllOrders={getAllOrders} />,
                ordered_items: <RenderOrderItems row={row} />,
                total_price: <span className='Custom--Text-dashed-line'><Text as='span'>{getTotalPrice(row)}</Text></span>,
                created_at: row?.['source_created_at'] ? formattedDate(row?.['source_created_at']) : "N/A",
                tags: <RenderTags row={row} key={idx} />,
                actions: <RenderActions
                    current={idx + 1}
                    row={row}
                    setShowSkeleton={setShowSkeleton}
                    getAllOrders={getAllOrders}
                    pageSize={pageSize}
                    totalOrders={totalOrders}
                    currentPage={activePage}
                    refreshAction={refreshAction}
                    key={idx}
                />,
                date: row?.['created_at'],
                orderId: row?.marketplace_reference_id,
                cif_order_id: orderId
            })
        })

        setGridRows([...temp])
    }, [DataForRow, activePage, totalOrders])

    /**
     * Handles the change of the selected tab
     * @param {number} selectedTabIndex The index of the selected tab
     */
    const handleTabChange = useCallback((selectedTabIndex: number): void => {
        setLoader(true)
        setSelected(selectedTabIndex)
        setSelectedRows([])
    }, []);

    /**
     * Toggles the active state of the popover
     */
    const togglePopoverActive = useCallback((): void => setPopoverActive((popoverActive) => !popoverActive), []);

    /**
     * Function to prepare filters based on provided criteria
     * @returns {Object} The prepared filter object
    */
    const prepareFilter = (): object => {
        let tempFilter: ObjectI = {};
        Object.keys(filter).map((key: string) => {
            if (filter[key].change) {
                if (key == 'Tags') {
                    tempFilter[`filter[${filter[key]['value']}][${filter[key]['selectValue']}]`] =
                        filter[key]['textValue'] === 'is_ispu' ? true : filter[key]['textValue']
                }
                else if (key === 'Status') {

                    if (filter[key]['textValue'] === 'Cancelled') {
                        tempFilter[`filter[targets.cancellation_status][${filter[key]['selectValue']}]`] = filter[key]['textValue']
                    }
                    else if (filter[key]['textValue'] === 'Shipped') {
                        tempFilter[`filter[${filter[key]['platform']}][1]`] = filter[key]['textValue']
                    }
                    else if (filter[key]['textValue'] === 'Failed') {
                        tempFilter[`filter[targets.return_status][1]`] = filter[key]['textValue']
                    }
                    else
                        tempFilter[`filter[${filter[key]['platform']}][${filter[key]['selectValue']}]`] = filter[key]['textValue']
                }
                else if (key === 'Order Date') {
                    if (filter[key]['textValue'] === 'Custom') {
                        tempFilter[`filter[${filter[key]['value']}][7][from]`] = filter[key]['start']
                        tempFilter[`filter[${filter[key]['value']}][7][to]`] = filter[key]['end']
                    }
                    else {
                        tempFilter[`filter[${filter[key]['value']}][7][from]`] = filter[key]['start']
                    }
                }
                else if (key === 'Sync Status') {
                    if (filter[key]['label'] === "Failed Order") {
                        tempFilter[`or_filter[0][filter][${paramKey(filter[key]['value'])}][${filter[key]['selectValue']}]`] = filter[key]['textValue']
                        tempFilter['or_filter[0][filter][marketplace_status][2]'] = 'Canceled'
                        tempFilter['or_filter[0][filter][targets.order_id][10]'] = false
                    }
                    else if (filter[key]['label'] === "Refunded") {
                        console.log(filter[key]['value'], filter[key]['selectValue'], "cfgvbhjn");

                        tempFilter[`filter[${paramKey(filter[key]['value'])}][${filter[key]['selectValue']}]`] = filter[key]['textValue']
                        tempFilter[`filter[targets.refund_status][4]`] = "Failed"
                    }
                    else if (filter[key]['value'] === "failed_shipment") {
                        tempFilter[`filter[${paramKey(filter[key]['value'])}][${filter[key]['selectValue']}]`] = filter[key]['textValue']
                        tempFilter[`filter[marketplace_status][1]`] = "Unshipped"


                    }
                    else
                        tempFilter[`filter[${paramKey(filter[key]['value'])}][${filter[key]['selectValue']}]`] = filter[key]['textValue']
                }
                else if (key === "Orders") {
                    tempFilter[`filter[user_id][1]`] = props.redux.user_id
                    tempFilter[`filter[object_type][1]`] = "source_order"
                    tempFilter[`filter[marketplace][1]`] = props.redux.current.target?.marketplace
                    tempFilter[`filter[marketplace_shop_id][1]`] = props?.redux?.current?.target?._id
                    tempFilter[`filter[marketplace_status][1]`] = "Unshipped"
                    tempFilter[`filter[attributes.key][1]`] = "Amazon LatestShipDate"
                    tempFilter[`filter[attributes.value][7][from]`] = filter[key]['from']
                    tempFilter[`filter[attributes.value][7][to]`] = filter[key]['to']
                    tempFilter[`unwind`] = "attributes"
                    tempFilter[`or_filter[0][filter][targets.status][1]`] = "Created"
                    tempFilter[`or_filter[1][filter][shipment_error][10]`] = true
                }
                else if (key === 'Price') {
                    tempFilter[`filter[${filter[key]['value']}][${filter[key]['selectValue']}]`] = filter[key]['textValue']
                }
                else {
                    tempFilter[`filter[${filter[key]['textValue']}][${filter[key]['selectValue']}]`] = filter[key]['value']
                }
            }
        }
        );
        return tempFilter;
    };

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(today.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    /**
     * Function to fetch the count of error orders
     * @returns {Promise<void>} A Promise that resolves when the operation is complete
    */
    const getErrorCount = async (): Promise<void> => {
        // let filters = prepareFilter();
        // if (Object.keys(filters).length > 0) {
        //     obj = { ...obj, ...filters }
        // }

        // Create object with filters
        let obj: ObjectI = {
            'filter[object_type][1]': "source_order",
            'filter[marketplace][1]': props.redux.current.target?.marketplace,
            'filter[marketplace_shop_id][1]': props?.redux?.current?.target?._id,
            'or_filter[0][filter][targets.status][1]': 'failed',
            'or_filter[0][filter][marketplace_status][2]': 'Canceled',
            'or_filter[0][filter][targets.order_id][10]': false,
            'or_filter[1][filter][shipment_error][10]': true,
            'or_filter[2][filter][targets.cancellation_status][1]': 'Failed',
            'or_filter[3][filter][refund_status][3]': 'Failed',
        };
        const payload: any = {
            'refresh': true,
            'filter': {
                ...necessaryInfo(props),

            },
            "or_filter": [
                { "filter": { "targets.status": { "1": "failed" }, "marketplace_status": { "2": "Canceled" }, "targets.order_id": { "10": false } } },
                { "filter": { "shipment_error": { "10": true }, "marketplace_status": { "1": "Unshipped" }, "attributes.key": { "1": "Amazon LatestShipDate" }, "attributes.value": { "7": { "to": getCurrentDate() } }, "pi_removed": { "10": false }, "shipping_status": { "1": "Unshipped" }, } },
                { "filter": { "targets.cancellation_status": { "1": "Failed" } } },
                { "filter": { "refund_status": { "3": "Failed" } } }
            ],

        }
        // Fetch count of error orders
        let response = await props.di.POST('connector/order/getCount', payload);
        if (response.success) setErrorTabCount(response?.data?.count ?? "00");
        else props.error(t(response?.message));
    }


    useEffect(() => {
        const handleSearchParamUpdates = (): void => {
            const updatedFilter: Filter = { ...filter }; // Ensure Filter type safety
            // Efficiently check for failed statuses using a lookup object
            const failedStatusMap: { [key: string]: FailedStatus } = {
                failed_order: { change: true, label: "Failed Order", selectValue: "1", textValue: "failed", value: "failed_order" },
                failed_refund: { change: true, label: "Failed Refund", selectValue: "3", textValue: "Failed", value: "failed_refund" },
                failed_shipment: { change: true, label: "Failed Shipment", selectValue: "10", textValue: "true", value: "failed_shipment" },
                failed_cancellation: { change: true, label: "Failed Cancellation", selectValue: "1", textValue: "Failed", value: "failed_cancellation" }
            };

            const searchParamsEntries = Array.from(searchParams.entries());
            const hasFailedStatuses = searchParamsEntries.some(([key]) => key.startsWith("failed_"));
            if (hasFailedStatuses) {
                // Clear local storage if any failed statuses exist
                props.di.globalState.removeLocalStorage('orders_filter');
                // Update filter for each failed status efficiently using the lookup
                Object.keys(failedStatusMap)
                    .filter((param: string) => searchParams.has(param))
                    .forEach((param: string) => {
                        updatedFilter['Sync Status'] = { ...updatedFilter['Sync Status'], ...failedStatusMap[param] };
                        searchParams.delete(param);
                    });

                setSearchParams(searchParams); // Update search params after modifications
            }
            setFilter(updatedFilter);
        };

        // Call the logic only when searchParams changes
        handleSearchParamUpdates();
    }, [searchParams]);
    /**
     * Function to fetch all orders based on provided filters
     * @returns {Promise<void>}
     */
    const getAllOrders = async (): Promise<void> => {
        setShowSkeleton(true);
        setLoader(true);
        let filters = {}
        let payload: PayloadI = {
            'activePage': activePage,
            'count': pageSize,
            'filter[object_type][1]': "source_order",
            'filter[marketplace][1]': props?.redux?.current?.target?.marketplace || '',
            'filter[marketplace_shop_id][1]': props?.redux?.current?.target?._id || ''
        };
        if (searchParams.getAll("error").length > 0) {
            props.di.globalState.removeLocalStorage('orders_filter');
            if (searchParams.get("error")) {
                setActivePage(1)
                setOrderStatus('errors')
                handleTabChange(1)
                setInputValue("")
                searchParams.delete('error');
                setSearchParams(searchParams);
            }
        } else if (searchParams.getAll("orderId").length > 0) {
            props.di.globalState.removeLocalStorage('orders_filter');
            if (searchParams.get("orderId")) {
                payload['filter[marketplace_reference_id][3]'] = searchParams.get("orderId");
                setInputValue(searchParams.get("orderId") || '');
                searchParams.delete('orderId');
                setSearchParams(searchParams);
            }
        }
        filters = prepareFilter();
        if (Object.keys(filters).length > 0) {
            payload = { ...payload, ...filters };
        };

        if (inputValue && inputValue != "") {
            payload['filter[marketplace_reference_id][3]'] = inputValue;
        };

        if (inputValue !== prevInput.current && activePage !== 1) {
            payload.activePage = 1;
            setActivePage(1);
            return;
        };

        if (orderStatus === 'errors') {
            if (Object.keys(filters).length > 0) {
                payload = { ...payload, ...filters };
            }
            else {
                payload['or_filter[0][filter][targets.status][1]'] = 'failed'
                payload['or_filter[0][filter][marketplace_status][2]'] = 'Canceled'
                payload['or_filter[0][filter][targets.order_id][10]'] = false
                payload['or_filter[1][filter][shipment_error][10]'] = true
                payload['or_filter[2][filter][targets.cancellation_status][1]'] = 'Failed'
                payload['or_filter[3][filter][refund_status][3]'] = 'Failed'
            }
        }


        let response = await props.di.GET('connector/order/getAll', payload);
        if (response.success && response?.data?.rows?.length > 0) {
            setDataforRow([...response?.data?.rows])
            setTotalPages(Math.ceil(response?.data?.['count'] / pageSize));
            setShowSkeleton(false);
            setLoader(false);
            setTotalOrders(response?.data?.count || 0)
        }
        else {
            setShowSkeleton(false);
            setLoader(false);
            setDataforRow([]);
            setGridRows([]);
        }
        prevInput.current = inputValue;
    }

    /**
     * Function to refresh orders and error count
     */
    const refreshAction = (): void => {
        getAllOrders();
        getErrorCount();
    }

    /**
     * Functions to handle the pagination to the previous page
     */
    const handlePreviousPagination = () => {
        setLoader(true)
        setActivePage(prev => prev - 1);
    }

    /**
     * Functions to handle the pagination to the next page
     */
    const handleNextPagination = () => {
        setLoader(true)
        setActivePage(prev => prev + 1);
    }

    /**
     * Function to open import modal
     */
    const handleImportBtn = () => {
        setActivateImportModal(!activateImportModal);
    }

    /**
     * function to close import modal
     */
    const handleImportModalClose = () => {
        setActivateImportModal(!activateImportModal);
        setImportOrderId('');
        setImportError(false)
    }

    /**
     * Handles the change in the import modal state and initiates the order import process
     */
    const handleImportModalChange = async () => {
        setImportLoader(true);
        let obj: any = {
            "source": { "marketplace": "shopify", "shopId": props?.redux?.current?.source?.['_id'] },
            "target": { "marketplace": "amazon", "shopId": props?.redux?.current?.target?.['_id'] },
            "source_order_ids": importOrderId
        }
        if (importOrderId && importOrderId != "" && importOrderId.trim().length > 0) {
            let response = await props.di.POST('connector/order/importOrder', obj);
            setImportLoader(false);
            if (response.success) {
                props.success(t("Order imported successfully."));
                refreshAction();
            }
            else {
                props.error(t(response?.message) ?? t("Oops! Some error occured."))
                setImportOrderId('');
            }
            setActivateImportModal(!activateImportModal);
        }
        else {
            props.error(t("Kindly fill Amazon order id to proceed importing of orders."))
            setImportLoader(false);
            setImportError(true);
        }
    };

    /**
     * Archive Order Function
     */
    const archiveFailedOrders = () => {
        setArchiveModal({ open: true, loader: true })
        const matchedOrderIds = gridRows
            .filter(item => selectedRows.includes(item.key))
            .map(item => item.orderId);
        props.di.POST('amazon/request/moveOrderDataInArchiveCollectionBulk', {
            order_ids: matchedOrderIds
        }).then((res: any) => {
            setSelectedRows([])
            setShowSkeleton(true)
            setArchiveModal({ open: false, loader: false })
            if (res?.success) {
                if (res.order_ids_failed_to_move?.length <= 0) {
                    props.success(t("Order(s) archived successfully."));
                    refreshAction()
                } else {
                    props.error(t(`Orders archived successfully. ${res.order_ids_failed_to_move?.length} failed due to incomplete lifecycle.`));
                    refreshAction()
                }

            }
            else {
                props.error(t(res?.message) ?? t("Oops! Some error occured."))
                setSelectedRows([]);
            }
        })
    }

    /**
     * function used remove the filter tags
     * @param {string} value The value of the filter query
     */
    const handleFiltersQueryChange = useCallback((value: string): void => {
        let temp: any = { ...filter }
        Object.keys(temp).map(key => {
            if (value == key) {
                temp[key]['textValue'] = ""
                temp[key]['change'] = false
                temp[key]['label'] = ""
                if (key === 'Sync Status') {
                    temp[key]['value'] = '';
                    temp[key]['temp'] = 'xdcf'

                }

                if (temp[key].hasOwnProperty('label')) temp[key]['label'] = '';
                if (temp[key].hasOwnProperty('label2')) temp[key]['label2'] = '';
                if (temp[key].hasOwnProperty('platform')) temp[key]['platform'] = '';
                setFilter(temp)
                props.di.globalState.set('orders_filter', JSON.stringify(temp), true)
            }
        })
    }, [filter]);

    /**
     * Handles the removal of a query value from the filters
     * @param {string} flag The flag indicating the query value to be removed
     */
    const handleQueryValueRemove = useCallback((flag: string) => {
        Object.keys(filter).map(key => {
            let temp = { ...filter }
            if (key == flag) {
                temp[key]['textValue'] = ""
                temp[key]['change'] = false
                if (key === 'Sync Status') temp[key]['value'] = ''
                if (temp[key].hasOwnProperty('label')) temp[key]['label'] = '';
                if (temp[key].hasOwnProperty('label2')) temp[key]['label2'] = '';
                if (temp[key].hasOwnProperty('platform')) temp[key]['platform'] = '';
                setAppliedFilters([])
                setSelectedDate(['Select Date'])
                setFilter({ ...temp })
                props.di.globalState.set('orders_filter', JSON.stringify(temp), true)
            }
        })
    }, [filter]);

    useEffect(() => {
        var temp: any = { ...appliedFilters }
        Object.keys(filter).map(key => {
            if (filter[key].change) {
                if (key == 'Tags') {
                    temp[key] = {
                        key: key,
                        label: `${t(key)} ${selectOption.filter(val => { return val?.value == filter?.[key]?.selectValue })?.[0]?.['label']} ${filter[key]['label']}`,
                        onRemove: handleQueryValueRemove,
                    }
                }
                else if (key == 'Status') {
                    temp[key] = {
                        key: key,
                        label: `${filter[key]['label']} ${t(key)} ${selectOption.filter(val => { return val?.value == filter?.[key]?.selectValue })?.[0]?.['label']} ${filter[key]['label2']}`,
                        onRemove: handleQueryValueRemove,
                    }
                }
                else if (key == 'Order Date') {
                    if (filter[key]['textValue'] === 'Custom') {
                        temp[key] = {
                            key: key,
                            label: `${key}: ${filter[key]['start']} - ${filter[key]['end']?.includes('T23:59:59') ? filter[key]['end']?.replace('T23:59:59', "") : filter[key]['end']}`,
                            onRemove: handleQueryValueRemove,
                        }
                    }
                    else {
                        temp[key] = {
                            key: key,
                            label: `${t(key)}: ${filter[key]['textValue']}`,
                            onRemove: handleQueryValueRemove,
                        }
                    }
                }
                else if (key === 'Sync Status') {
                    temp[key] = {
                        key: key,
                        label: `${t(key)}: ${filter[key]['label']}`,
                        onRemove: handleQueryValueRemove
                    }
                }
                else if (key === 'Orders') {
                    temp[key] = {
                        key: key,
                        label: `${t(key)} ${t(filter[key]['textValue'])}`,
                        onRemove: handleQueryValueRemove
                    }
                }
                else {
                    temp[key] = {
                        key: key,
                        label: `${t(key)} ${selectOption.filter(val => { return val?.value == filter?.[key]?.selectValue })?.[0]?.['label']} ${filter[key]['textValue']}`,
                        onRemove: handleQueryValueRemove,
                    }
                }
            } else {
                delete temp[key]
            }
        })
        setActivePage(1)
        setAppliedFilters(temp)
    }, [filter])

    return (
        <React.Fragment>
            {/* <Card roundedAbove='sm' padding="0"> */}
            <Box paddingInlineStart={"300"}>
                <div className='custom-remove-tab-padding custom-new-sales-tab'>
                    <Tabs
                        tabs={tabs}
                        selected={selected}
                        onSelect={(e) => {
                            props.di.globalState.removeLocalStorage("orders_filter")
                            setFilter(JSON.parse(JSON.stringify({ ...ordersFilter })))
                            setActivePage(1)
                            setOrderStatus(tabs[e].id)
                            handleTabChange(e)
                            setInputValue("")
                        }}
                    />
                </div>
            </Box>
            <Bleed marginInline="0">
                <Divider />
            </Bleed>
            <Box padding={{ xs: '200', sm: '200', md: '500', xl: '500' }} paddingBlockStart={"0"}>
                <BlockStack gap="200">
                    <InlineStack gap="400">
                        <div className='Custom__Filter--GridSale'>
                            <RenderFilters
                                filter={filter}
                                setFilter={setFilter}
                                handleTabChange={handleTabChange}
                                appliedFilters={appliedFilters}
                                setAppliedFilters={setAppliedFilters}
                                selected={selectedDate}
                                setSelected={setSelectedDate}
                                handleQueryValueRemove={handleQueryValueRemove}
                                inputValue={inputValue}
                                setInputValue={setInputValue}
                            />
                        </div>
                        {/* <Button icon={<Icon source={ArchiveMajor} tone="base" />} onClick={() => props.history(`../archived-order/allSales`)}>{t("Archived Orders")}</Button> */}
                        <Button disabled={!props.redux.sync_activated && !isAdminLoggedIn()} icon={ImportMinor} onClick={handleImportBtn}>{t("Import Orders")}</Button>
                    </InlineStack>
                    <InlineStack gap='400'>
                        {
                            Object.keys(appliedFilters).length > 0 && Object.keys(appliedFilters).map(filter => {
                                return <Tag onRemove={() => handleFiltersQueryChange(filter)} key={filter}>
                                    <span> {appliedFilters?.[filter]?.label} </span>
                                </Tag>
                            })
                        }
                    </InlineStack>
                    <BlockStack gap="200">
                        {
                            !showSkeleton && DataForRow.length === 0 ?
                                <InlineStack align="center" gap="400">
                                    <EmptyState image={NoResultsFound} heading={"No Orders Found"} />
                                </InlineStack>
                                :
                                <BlockStack gap='200'>
                                    <Table
                                        sticky
                                        size='middle'
                                        columns={allOrderCols}
                                        dataSource={(!loader && gridRows?.length > 0) ? gridRows : skeletonRow}
                                        scroll={{ x: 1200 }}
                                        ref={tableref}
                                        pagination={false}
                                        rowSelection={{
                                            onSelect: (value) => {
                                                let temp = [...selectedRows];
                                                if (temp.includes(value?.['key'])) {
                                                    temp.splice(temp.indexOf(value['key']), 1);
                                                } else temp.push(value['key']);
                                                setSelectedRows([...temp]);
                                            },
                                            onSelectAll: (_, rows) => {
                                                let temp: Array<any> = [];
                                                rows.forEach((row) => {
                                                    temp.push(row?.['key']);
                                                });
                                                setSelectedRows([...temp]);
                                            },
                                            selectedRowKeys: selectedRows,
                                        }}
                                        summary={() => (
                                            selectedRows.length > 0 ?
                                                <Table.Summary fixed="top">
                                                    <Table.Summary.Row>
                                                        <Table.Summary.Cell index={0} colSpan={5}>
                                                            <InlineStack gap="400">
                                                                <div className='Custom__Btn--Grp'>
                                                                    <ButtonGroup variant="segmented">
                                                                        <Button
                                                                            size="slim"
                                                                            icon={<Checkbox
                                                                                onChange={(_) => {
                                                                                    if (selectedRows.length > 0 && selectedRows.length == gridRows.length) {
                                                                                        setSelectedRows([]);
                                                                                    } else if (selectedRows.length > 0 && gridRows.length > selectedRows.length) {
                                                                                        let rowTempData: any = [];
                                                                                        gridRows.map((row: any) => rowTempData.push(row['key']));
                                                                                        setSelectedRows(rowTempData);
                                                                                    }
                                                                                }}
                                                                                checked={selectedRows.length < gridRows.length ? 'indeterminate' : true}
                                                                                label={''}
                                                                            />}
                                                                        >
                                                                            {selectedRows.length + " selected"}
                                                                        </Button>
                                                                        <Button onClick={() => setSelectedRows([])} size="medium" icon={MobileCancelMajor} />
                                                                    </ButtonGroup>
                                                                </div>
                                                                <Popover
                                                                    active={popoverActive}
                                                                    activator={<Button onClick={togglePopoverActive} disclosure>{t("Select Actions")}</Button>}
                                                                    autofocusTarget="first-node"
                                                                    onClose={togglePopoverActive}
                                                                >
                                                                    <ActionList
                                                                        actionRole="menuitem"
                                                                        items={[
                                                                            {
                                                                                content: t('Archive Orders'),
                                                                                onAction: () => setArchiveModal({ open: true, loader: false })
                                                                            }
                                                                        ]}
                                                                    />
                                                                </Popover>
                                                            </InlineStack>
                                                        </Table.Summary.Cell>
                                                    </Table.Summary.Row>
                                                </Table.Summary>
                                                : null
                                        )}
                                    />
                                    <InlineStack align="center" gap="400">
                                        <Pagination
                                            label={`${activePage}/${totalPages}`}
                                            hasPrevious={activePage > 1 && !loader}
                                            onPrevious={() => handlePreviousPagination()}
                                            hasNext={activePage < totalPages && !loader}
                                            onNext={() => handleNextPagination()}
                                        />
                                    </InlineStack>
                                </BlockStack>
                        }
                    </BlockStack>
                </BlockStack>
            </Box>
            {/* </Card> */}

            {/* Import Order Modal */}
            {
                customModal(activateImportModal, handleImportModalClose, `${t("Import Order(s)")}`, {
                    content: t('Confirm'),
                    onAction: handleImportModalChange,
                    loading: importLoader
                },
                    <TextField error={importError} value={importOrderId} onChange={(e) => { setImportOrderId(e); setImportError(e == "") }} autoComplete="off" placeholder={t('Enter Amazon Order Id')} label={t("Amazon order id:")} />,
                    false,
                    [
                        {
                            content: t('Cancel'),
                            onAction: handleImportModalClose,
                            disabled: importLoader
                        }
                    ])}

            {customModal(
                archiveModal?.open,
                () => setArchiveModal({ open: false, loader: false }),
                "Archive Order",
                {
                    content: "Confirm",
                    onAction: () => archiveFailedOrders(),
                    loading: archiveModal?.loader
                },
                <Text as='p'>{t("Are you sure you want to archive the order(s)?")}</Text>,
                false
            )}
        </React.Fragment>
    );
}

export default DI(NewAllSales);